import { CLASS_GANTT_VIEW } from '../../constants';

export const CLASS_GANTT_CARD = CLASS_GANTT_VIEW + '-card';
export const CLASS_GANTT_CARD_CONTROL = CLASS_GANTT_CARD + '-control';
export const CLASS_GANTT_CARD_FIELD = CLASS_GANTT_CARD + '__field';
